export function svgzoom(node, params) {
  return {
    delay: params.delay || 0,
    duration: params.duration || 1000,
    easing: params.easing,
    css: (t, u) => `transform:  scale(${t})`
  };
}
